import { BigNumber } from '@ethersproject/bignumber';
import { formatBigNumber } from './formatBigNumber';

// calculateTVL calculates Token USDC value from Token value 
export function calculateTVL(supply: BigNumber, decimals: number, usdPrice: number) {
  return Number(formatBigNumber(supply, decimals, 6)) * usdPrice;
}